import {areaTelNameList} from '../config';
export default function () {
  // SYSTEM-1009
  // URLに東京以外の名前が入っていたらAB検証除外
  const $aba = document.getElementsByClassName('ab-a');
  const $abb = document.getElementsByClassName('ab-b');
  areaTelNameList.forEach((item, i) => {
    if (location.href.indexOf(item) !== -1 && item !== 'tokyo') {
      Array.prototype.forEach.call($aba, function (element) {
        element.classList.add('display-none');
      });
      Array.prototype.forEach.call($abb, function (element) {
        element.classList.add('display-none');
      });
    }
  });
}
